<!-- <p>modal-pasajero-confirmado works! seguro!!!!</p> -->
<!-- Modal -->

<div id="pasajero-confirmado" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="margin: auto;">
      <div class="modal-content">
        <div class="modal-header d-block border-0 text-center">
          <img src="/assets/images/body/reserva-ok.svg" class="mt-5 mb-3" alt="">
          <h3 class="modal-title text-secondary text-center m-auto" id="loginLabel">Pasajero confirmado</h3>

          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          
          <i class="bi-x modal-close" aria-label="Close" (click)="closeModal()"></i>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">
             
              <p class="text-secondary text-center mt-5">
                <a style="cursor: pointer;" aria-label="Close" (click)="closeModal()" class="btn btn-lg btn-primary btn-reservar rounded-pill" >Volver</a>
              </p>
            </div>
            <div class="col-lg-2"></div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <img src="/assets/images/body/reserva-ok-personas.svg" class="d-none d-lg-block" alt="">
        
        </div>
      </div>
    </div>
  </div>
